import type { AppConfig } from '../config';

import { isLocationBasedReviewRoute } from './isLocationBasedReviewRoute';

export const getLocationId = (params: {
  locationSlug?: string;
  reviewLocation: AppConfig['reviewLocation'];
}): number | undefined =>
  isLocationBasedReviewRoute({
    locationSlug: params.locationSlug,
    locationId: params.reviewLocation.details?.locationId,
  })
    ? params.reviewLocation.details?.locationId
    : undefined;
